import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompositePropertyValueModel } from 'projects/phdsoft/common/src/lib/models/composite-property-value';
import { CompositePropertyModel } from 'projects/phdsoft/common/src/lib/models/composite-property.model';
import { ElementTypeModel } from 'projects/phdsoft/common/src/lib/models/element-type.model';
import { PropertyDefinitionModel } from 'projects/phdsoft/common/src/lib/models/property-definition.model';
import { UnitTypesModel } from 'projects/phdsoft/common/src/lib/models/unit-types.model';
import { Observable, forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElementTypesService {

    constructor(
      private http: HttpClient
    ) { }

    getAssetElementTypes(assetId: string) {
      return this.http.get<ElementTypeModel[]>(
          environment.API_THREED + `ElementTypes/ElementType?assetId=${assetId}`
      );
    }

    createElementType(elementType: ElementTypeModel, assetId: string){
      return this.http.post(
          environment.API_THREED + `ElementTypes/ElementType?assetId=${assetId}`, elementType
      )
    }

    updateElementType(elementType: ElementTypeModel, assetId: string){
      return this.http.put(environment.API_THREED + `ElementTypes/ElementType?assetId=${assetId}`, elementType)
    }

    deleteElementType(elementTypeId: string, assetId: string){
      return this.http.delete(
          environment.API_THREED + `ElementTypes/ElementType?elementTypeId=${elementTypeId}&assetId=${assetId}`
      )
    }

    getAssetProperties(assetId: string) {
      return this.http.get<PropertyDefinitionModel[]>(
          environment.API_THREED + `ElementTypes/Property?assetId=${assetId}`
      );
    }

    createProperty(property: PropertyDefinitionModel, assetId: string){
      return this.http.post(
          environment.API_THREED + `ElementTypes/Property?assetId=${assetId}`, property
      )
    }

    updateProperty(property: PropertyDefinitionModel, assetId: string){
      return this.http.put(environment.API_THREED + `ElementTypes/Property?assetId=${assetId}`, property)
    }

    deleteProperty(propertyId: string, assetId: string){
      return this.http.delete(
          environment.API_THREED + `ElementTypes/Property?propertyId=${propertyId}&assetId=${assetId}`
      )
    }

    getAssetCompositeProperties(assetId: string) {
      return this.http.get<CompositePropertyModel[]>(
          environment.API_THREED + `ElementTypes/CompositeProperty?assetId=${assetId}`
      );
    }

    createCompositeProperty(compositeProperty: CompositePropertyModel, assetId: string){
      return this.http.post(
          environment.API_THREED + `ElementTypes/CompositeProperty?assetId=${assetId}`, compositeProperty
      )
    }

    updateCompositeProperty(compositeProperty: CompositePropertyModel, assetId: string){
      return this.http.put(environment.API_THREED + `ElementTypes/CompositeProperty?assetId=${assetId}`, compositeProperty)
    }

    deleteCompositeProperty(compositePropertyId: string, assetId: string){
      return this.http.delete(
          environment.API_THREED + `ElementTypes/CompositeProperty?compositePropertyId=${compositePropertyId}&assetId=${assetId}`
      )
    }

    getAssetCompositePropertiesValues(assetId: string) {
      return this.http.get<CompositePropertyValueModel[]>(
          environment.API_THREED + `ElementTypes/Values?assetId=${assetId}`
      );
    }

    getAssetElementsAndProperties(assetId: string) {
      let properties = this.http.get<PropertyDefinitionModel[]>(
        environment.API_THREED + `ElementTypes/Property?assetId=${assetId}`
      )
      let compositeProperties = this.http.get<CompositePropertyModel[]>(
        environment.API_THREED + `ElementTypes/CompositeProperty?assetId=${assetId}`
      )
      let elements = this.http.get<ElementTypeModel[]>(
        environment.API_THREED + `ElementTypes/ElementType?assetId=${assetId}`
      )
      let compositePropertiesValues = this.http.get<CompositePropertyValueModel[]>(
        environment.API_THREED + `ElementTypes/Values?assetId=${assetId}`
      )
      return forkJoin([properties, compositeProperties, elements, compositePropertiesValues])
    }
}
